<template>
    <div class="list" @click="goDetail">
        <div class="clearfix">
            <div class="fl job_name">{{item.job_name}}</div>
            <div class="fr salary_package">{{item.salary_package}}{{item.salary_package === '面议'?'':'元/月'}}</div>
            </div>
            <div class="educational_require">{{item.educational_require}}</div>
            <div class="clearfix content">
            <div class="fl contentLeft">
                <el-avatar size="small" :src="item.school_avatar"></el-avatar>
                <span class="school_name textOverflow">{{item.school_name}}</span>
            </div>
            <div class="fr contentRight textOverflow"><i class="el-icon-location-outline"></i>
                {{item.province_name?item.province_name:''}}{{item.city_name?item.city_name:''}}{{item.dist_name?item.dist_name:''}}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            item: Object
        },
        methods: {
            goDetail() {
                let routeData = this.$router.resolve({
                    path:'/job/postDetail?jid=' + this.item.jid
                })
                window.open(routeData.href, '_blank');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .list {
        background: white;
        padding: 16px 20px;
        cursor: pointer;
        transition: all .5s;
        .salary_package {
            color: #fd7240;
        }
        .educational_require {
            padding-top: 5px;
            font-size: 13px;
            color: #8d92a1;
            padding-bottom: 10px;
            border-bottom: 1px solid #eef0f5;
        }
        .content {
            padding-top: 10px;
        }
        .contentLeft {
            width: 60%;
            >span {
                vertical-align: middle;
                display: inline-block;
            }
            .school_name {
                margin-left: 5px;
                color: #61687c;
                width: 80%;
            }
        }
        .contentRight {
            color: #61687c;
            font-size: 13px;
            height: 28px;
            line-height: 28px;
            width: 40%;
            text-align: right;
        }
    }
    .list:hover {
        box-shadow: 5px 5px 20px rgba(0,0,0,.05);
        .job_name {
            color: #FF5B12;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/list/index.vue